import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {fetchNotification} from 'src/openapi/admin/apis/InternalNotificationApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Error} from 'src/openapi/admin/models/Error';
import type {ErrorPayload, SuccessPayload} from 'src/typedef';

type NotificationWithContent = {
    title: string,
    content: string,
    notificationId: string,
};

type Props = {
    notifications: {title: string, notificationId: string}[],
};

export const useNotificationContentReader = ({notifications}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(async () => {
        const result: NotificationWithContent[] = [];
        let error: Error | null = null;

        for (const {notificationId, title} of notifications) {
            let content = '';
            const response = await apiDispatch(fetchNotification({notificationId}));

            if (response.payload.success) {
                content = response.payload.data.content || '';
            } else {
                error = response.payload.data;
            }
            result.push({title, content, notificationId});
        }

        if (!error) {
            return Promise.resolve({type: '', payload: {
                success: true,
                error: false,
                data: result,
            } as SuccessPayload<NotificationWithContent[]>});
        } else {
            return Promise.resolve({type: '', payload: {
                success: false,
                error: true,
                data: error,
            } as ErrorPayload});
        }
    }, [notifications, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
